import { CheckCircleIcon } from "@heroicons/react/24/outline";

/**
 * Confirmation shown after a successful in-app-browser purchase. When the user
 * completed checkout inside the mobile app's in-app browser we skip redirecting
 * (the app closes the window itself) and render this message instead.
 */
export function PurchaseSuccessCloseMessage() {
  return (
    <div className="flex w-full flex-col items-center gap-4 px-4 pt-24 text-center">
      <CheckCircleIcon className="h-16 w-16 text-green-500" />
      <h1 className="text-2xl font-bold">Purchase Successful!</h1>
      <p className="text-gray-500">You may close this window now.</p>
    </div>
  );
}
